import { Count, CountValue } from "@happy-legal/graphql-types";
import { graphQlClient } from "../clients";
import {
  MUTATION_DECREMENT_COUNT,
  MUTATION_INCREMENT_COUNT,
  MUTATION_SET_COUNT,
} from "../gql/mutations";
import { QUERY_GET_COUNT } from "../gql/queries";
import { countInitState } from "../providers/CountProvider";
import { handleCatchReducer } from "./handleCatchReducer";

export const GET_COUNT = "GET_COUNT";
type TGET_COUNT = { type: "GET_COUNT"; key: string };

export const DECREMENT_COUNT = "DECREMENT_COUNT";
type TDECREMENT_COUNT = {
  type: "DECREMENT_COUNT";
  key: string;
};

export const INCREMENT_COUNT = "INCREMENT_COUNT";
type TINCREMENT_COUNT = {
  type: "INCREMENT_COUNT";
  key: string;
};

export const SET_COUNT = "SET_COUNT";
type TSET_COUNT = {
  type: "SET_COUNT";
  key: string;
  payload: CountValue;
};

export type TCountAction =
  | TGET_COUNT
  | TDECREMENT_COUNT
  | TINCREMENT_COUNT
  | TSET_COUNT;

export const countReducer = async (state: Count, action: TCountAction) => {
  try {
    switch (action.type) {
      case GET_COUNT: {
        const newState = await graphQlClient(QUERY_GET_COUNT, {
          key: action.key,
        });

        return newState;
      }

      case DECREMENT_COUNT: {
        const newState = await graphQlClient(MUTATION_DECREMENT_COUNT, {
          key: action.key,
        });

        return newState;
      }

      case INCREMENT_COUNT: {
        const newState = await graphQlClient(MUTATION_INCREMENT_COUNT, {
          key: action.key,
        });

        return newState;
      }

      case SET_COUNT: {
        const newState = await graphQlClient(MUTATION_SET_COUNT, {
          key: action.key,
          value: action.payload,
        });

        return newState;
      }

      default: {
        return state;
      }
    }
  } catch (err) {
    handleCatchReducer("count", err);
    return countInitState;
  }
};
